import React from 'react'

import * as Yup from 'yup'
import { useIntl, useConfirm } from 'hooks'
import SharedWithUsers from 'components/Share/SharedWithUsers'
import MixedState from 'components/Share/SharedWithUsers/MixedState'
import EmailsList from 'components/Share/SharedWithUsers/EmailsList'
import ShareFileSettings from 'components/Share/ShareFileSettings'
import ShareMailPill from 'components/Share/ShareMailPill'
import { Input } from 'components/Form'
import { Button } from 'components/Zui'

const Form = ({
    values,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateField,
    validationSchema,
    setCreate,
    isMixed,
    isShareFromCollection,
    hasSharedWith,
}) => {
    const { t } = useIntl()
    const { getConfirmation } = useConfirm()

    const handleDeleteMail = async emailId => {
        const confirmed = await getConfirmation({
            title: t('revoke.access.title'),
            message: t('revoke.access.message', { email: emailId }),
            buttons: [t('cancel'), t('confirm')],
        })

        if (confirmed) {
            let updatedArr = []
            const isNewEmail = values.sharedWith.find(e => e.email === emailId && e.isNew)
            if (isNewEmail) {
                updatedArr = values.sharedWith.filter(e => e.email !== emailId)
            } else {
                updatedArr = values.sharedWith.map(e =>
                    e.email === emailId ? { ...e, flag: 'D' } : e
                )
            }
            setFieldValue('sharedWith', updatedArr)
        }
    }

    const handleDeleteMailPill = email => {
        const updatedArr = values.emails.filter(e => e.email !== email)
        setFieldValue('emails', updatedArr)
    }

    return (
        <>
            <div className="add-people-wrapper">
                <div className="add-people-form">
                    <div className="form-label-row">
                        <span>{t('add.people')}</span>
                    </div>
                    <div className="add-input-wrapper">
                        <div className="add-input-field-wrapper">
                            <Input
                                name="email"
                                type="email"
                                placeholder={t('placeholder.email')}
                                input-type="text"
                                style={{
                                    width: '100%',
                                    marginBottom: '0px ',
                                }}
                                noLabel
                            />
                        </div>

                        <div className="add-button">
                            <Button
                                onClick={async () => {
                                    await setCreate(true)
                                    await setFieldTouched('email')
                                    await validateField('email')

                                    const schema = Yup.object(validationSchema(t))
                                    const isValid = await schema.isValid({
                                        email: values.email,
                                        sharedWith: values.sharedWith,
                                        agreementUsers: values.agreementUsers,
                                    })

                                    if (isValid) {
                                        const emailField = hasSharedWith ? 'sharedWith' : 'emails'
                                        const emails = values[emailField]
                                        if (!emails.some(e => e.email === values.email)) {
                                            setFieldValue(emailField, [
                                                {
                                                    email: values.email,
                                                    isNew: true,
                                                    flag: 'C',
                                                    canRevoke: true,
                                                },
                                                ...emails,
                                            ])
                                        }
                                        setFieldValue('email', '')
                                        setFieldTouched('email', false)
                                        setFieldError('email', '')
                                    }
                                }}
                            >
                                {t('add')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {isMixed && (
                <ShareMailPill data={values.emails} handleDeleteMailPill={handleDeleteMailPill} />
            )}
            {values.sharedWith.filter(e => e.flag !== 'D').length > 0 && (
                <SharedWithUsers>
                    {isMixed ? (
                        <MixedState />
                    ) : (
                        <EmailsList
                            data={values.sharedWith.filter(e => e.flag !== 'D')}
                            handleDeleteMail={handleDeleteMail}
                        />
                    )}
                </SharedWithUsers>
            )}

            <ShareFileSettings
                isAnonymized={values.isAnonymized}
                isDownloadable={values.isDownloadable}
                isShareFromCollection={isShareFromCollection}
                setFieldValue={setFieldValue}
            />
        </>
    )
}

export default Form
